interface IColumnObject {
    dbField: string;
    displayField?: string;
    // key: string;
    value?: string | ActionType[];
    width?: string;
    minWidth?: string;
    maxWidth?: string;
    isHidden?: boolean;
}

// action type: add, edit, delete
enum ActionType {
    ADD_OPEN = "addOpen",
    ADD = "add",
    EDIT = "edit",
    EDIT_OPEN = "editOpen",
    EDIT_SAVE = "editSave",
    DELETE = "delete",
    DELETE_OPEN = "deleteOpen",
    DELETE_CONFIRM = "delete",
    CLOSE_MODAL = "closeModal",
    SORT = "sort",
}

export type { IColumnObject };
export { ActionType };